<script>
import AppHeader from "@/components/Essentials/AppHeader.vue";
import AppFooter from "@/components/Essentials/AppFooter.vue";
import Banner from "@/components/Ordre/Banner.vue";
import Content from "@/components/Ordre/Content.vue";

export default {
  name: "OrdrePage",
  components: {Content, Banner, AppFooter, AppHeader}
}
</script>

<template>
  <AppHeader></AppHeader>
  <Banner></Banner>
  <Content></Content>
  <AppFooter></AppFooter>
</template>

<style scoped>

</style>